import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, FlatList } from "react-native";
import { useDispatch } from "react-redux";

import { TransactionsLine } from "../card/TransactionLine";

import { setForm } from "@/context/actions/actions";
import { useAppSelector } from "@/context/hooks";
import { checkAsset } from "@/utils/transactions/ExchangeCurrencies";

interface Transaction {
  id: string;
  value: number;
  transactionPostedDate: string;
  transactionType: string;
  categoryType: string;
  transactionStatus: string;
  originator?: {
    rail: string;
    profile: {
      address: {
        country: string;
      };
    };
  };
}

interface TransactionSectionProps {
  data?: Transaction[];
}

export default function TransactionsSection(props: TransactionSectionProps) {
  const [isFiat, setIsFiat] = useState(false);
  const [assetCurrentAccountSelected, setAssetCurrentAccountSelected] =
    useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const globalValues = useAppSelector((state: any) => state);
  const TRANSACTIONS_MIN_ARRAY_SIZE = 15;

  const transactionsArray = props.data || [];

  useEffect(() => {
    const currentAccountSelected = globalValues.accountsData?.find(
      (objeto) => objeto.id === globalValues.currentAccountId
    );

    if (currentAccountSelected) {
      const asset = checkAsset(currentAccountSelected?.assetTypeId);
      setAssetCurrentAccountSelected(asset);

      if (asset === "USD" || asset === "EUR") {
        setIsFiat(true);
      } else {
        setIsFiat(false);
      }
    }
  }, [globalValues.currentAccountId]);

  const handleTransactions = () => {
    if (transactionsArray.length >= TRANSACTIONS_MIN_ARRAY_SIZE) {
      dispatch(setForm({ moreTransactionsLoading: true }));
    }
  };

  return (
    <>
      {transactionsArray.length <= 0 && (
        <View className="absolute z-50 h-full w-full items-center justify-center">
          <Text className="text-center text-lg font-normal">
            {t("common:placeholder.transactionsempty")}
          </Text>
        </View>
      )}
      <View className="w-full flex-row px-1 hidden md:flex">
        <View className="w-1/6 p-1">
          <Text className="font-medium text-xs text-center lg:text-sm">
            {t("common:placeholder.date")}
          </Text>
        </View>
        <View className="w-1/6 p-1">
          <Text
            numberOfLines={2}
            ellipsizeMode="tail"
            className="font-medium text-xs text-center lg:text-sm"
          >
            {t("common:placeholder.destinator")}
          </Text>
        </View>
        <View className="w-1/6 items-center justify-center">
          <Text className="font-medium text-xs text-center lg:text-sm">
            {t("common:placeholder.transfertype")}
          </Text>
        </View>
        <View className="w-1/6 p-1">
          <Text className="font-medium text-xs text-center lg:text-sm">
            {t("common:placeholder.amount")}
          </Text>
        </View>
        <View className="w-1/6 py-1">
          <Text className="font-medium text-xs text-center lg:text-sm">
            {t("common:placeholder.status")}
          </Text>
        </View>
        <View className="w-1/6 items-center justify-center p-1">
          <Text className="font-medium text-xs text-center lg:text-sm">
            {t("common:placeholder.receipt")}
          </Text>
        </View>
      </View>
      <FlatList
        className="h-full w-full p-1"
        data={transactionsArray.filter(
          (item) => item !== null && item !== undefined
        )}
        renderItem={({ item }) => (
          <TransactionsLine
            {...item}
            isFiat={isFiat}
            currentAsset={assetCurrentAccountSelected}
          />
        )}
        keyExtractor={(item, index) => item.id ?? index.toString()}
        onEndReached={() => {
          if (!globalValues.isTransactionsFiltered) {
            handleTransactions();
          }
        }}
        showsVerticalScrollIndicator={false}
      />
    </>
  );
}
